import React from 'react'
import { Navigate } from 'react-router-dom';
import { havePermission, isAuthenticated } from '../../helpers/helpers';

const PrivateRoute = ({ permissions = null, children, redirectTo = "/login" }) => {
  const auth = isAuthenticated();

  const haveThePermission = permissions === null ? true : permissions.some(permission => havePermission(permission));

  return auth && haveThePermission ? children : <Navigate to={redirectTo} replace />;
}

export default PrivateRoute